export default __webpack_public_path__ + "static/media/eating.0cac5175.svg";